import { Component, OnInit } from '@angular/core';
import {BundeslandFilterService} from '../../../../../../service/bundeslandFilter/bundesland-filter.service';
import {BundesLandName} from '../../../../../../model/component/bundesland';
import {MatTabChangeEvent} from '@angular/material/tabs';

@Component({
  selector: 'app-wassersport-wetter',
  templateUrl: './wassersport-wetter.component.html',
  styleUrls: ['./wassersport-wetter.component.css']
})
export class WassersportWetterComponent implements OnInit {

  selectedBundesland: string;
  selectedIndex = 0;


  constructor(public bundeslandFilterService: BundeslandFilterService) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
  }

  ngOnInit(): void {
  }


  isAvailableForBundesland() {
    return this.selectedBundesland === BundesLandName.BE || this.selectedBundesland === BundesLandName.BB;
  }
  onTabChange($event: MatTabChangeEvent) {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = 0;
  }

}
